import React, { useEffect, useState } from "react";
import {
  ChangeActive,
  getCategory,
  getDataWith_catId,
  getDataWith__ID,
  getTag,
  SearchPosts,
  token,
} from "../../API";
import EditCat from "../../Components/EditCat";
import EditPost from "../../Components/EditPost";
import EditTag from "../../Components/EditTag";
import { Button, Divider, Input, TextField } from "@material-ui/core";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { MdArrowBackIosNew, MdSearch } from "react-icons/md";
import { BiCloudDownload, BiTrash, BiEditAlt } from "react-icons/bi";
import EditPostChild from "../../Components/EditpostChild";
import UpdateStyles from "./updateStyled";
import axios from "axios";
// toast
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// switch
import Switches from "../../Components/TextSwitch";

const itemsToEdit = [
  { title: "Tegni o'zgartirish" },
  { title: "Kategoriyani o'zgartirish" },
  {
    title: "Yangilikni o'zgartirish",
  },
];
const getAllPosts = async (page) => {
  if (page !== undefined) {
    const url = `http://164.90.236.174:1988/koinot/news/list?page=${page}`;
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };
    try {
      const res = await axios.get(url, headers);
      return res;
    } catch (error) {
      console.error(error);
      return { error: true, error };
    }
  }
};

const Update = () => {
  const [tags, setTags] = useState([]);
  const [cats, setCats] = useState([]);
  // posts
  const [postsBoolean, setPostsBoolean] = useState("d-none");
  const [posts, setPosts] = useState([]);
  const [oldPosts, setOldPosts] = useState([]);
  const [children, setChild] = useState([]);
  const [childBool, setChildBool] = useState(false);
  const [newsdto, setNewsdto] = useState([]);
  const [pathBool, setPathBool] = useState(true);
  const [mapBool, setMapBool] = useState(false);
  const [index, setIndex] = useState(0);
  const [activeNews, setActiveNews] = useState([]);
  const [search, setSearch] = useState("");
  const [loadPage, setLoadPage] = useState(1);
  const [success, setSuccess] = useState(false);
  //
  const get_allPosts = async () => {
    let data = await getAllPosts(0);
    console.log(data);
    setOldPosts(
      data.data.object.content.map((v) => {
        return {
          titleUz: v.titleUz,
          id: v.id,
          status: v.status,
          active: v.active,
          textUz: v.textUz,
        };
      })
    );
    setPosts(
      data.data.object.content.map((v) => {
        return {
          titleUz: v.titleUz,
          id: v.id,
          status: v.status,
          active: v.active,
          textUz: v.textUz,
        };
      })
    );
  };

  // addchild

  const AddChild = () => {
    setChildBool(true);
    let childrenn = [
      ...children,
      {
        file: { link: null },
        link: "string",
        newsId: newsdto[0].id,
        textEn: "string",
        textRu: "string",
        textUz: "string",
        textUzK: "string",
        titleEn: "string",
        titleRu: "string",
        titleUz: "string",
        titleUzK: "string",
      },
    ];
    setChild(childrenn);
  };

  useEffect(() => {
    const getTags = async () => {
      let data = await getTag();
      setTags(data.data.objectKoinot);
    };
    getTags();
    const getCats = async () => {
      let data = await getCategory();
      setCats(data.data.objectKoinot);
    };
    getCats();

    get_allPosts();
    return () => {
      setTags([]);
      setCats([]);
      setPosts([]);
    };
  }, []);

  //  toast
  const successCallback = (text, success) => {
    if (success == "s") {
      toast.success(text);
    } else {
      toast.error(text);
    }
  };

  // posts

  const getPost = async (id) => {
    console.log(id);
    let data = await getDataWith__ID(id);
    if (data.status !== 404) {
      console.log(data.data.object.newsDto);
      setNewsdto([data.data.object.newsDto]);
      if (data.data.object.newsChildDto.length !== 0) {
        setChild(data.data.object.newsChildDto);
        setChildBool(true);
      }
      console.log(data.data.object.newsChildDto);
      setMapBool(true);
      setPostsBoolean("d-block");
      setPathBool(false);
      setSuccess(false);
    } else {
      toast.error(
        `Xatolik ! Internetni tekshiring yoki logout qilib qayta kiring`
      );
    }
    console.log(data);
  };
  // save
  useEffect(() => {
    if (success) {
      get_allPosts();
    }
  }, [success]);

  //

  const LoadHandler = async () => {
    let res = await getAllPosts(loadPage);
    console.log(res);
    let oldPosts = [...posts, ...res.data.object.content];
    setPosts(oldPosts);
    setLoadPage(loadPage + 1);
  };

  // ----search----
  const getFilteredItems = async (query, items) => {
    console.log(query, " ", items);
    if (query === "") {
      setPosts(oldPosts);
    } else {
      // setPosts(items.filter((post) => post.titleUz.includes(query)));
      let data = await SearchPosts(query);
      console.log(data);
      setPosts(data.data.object.content);
      console.log(data.data.object.content);
    }
  };
  useEffect(() => {
    getFilteredItems(search, posts);
  }, [search]);

  // change active
  const changeActive = async (id, v) => {
    const res = await ChangeActive(id, v);
    get_allPosts();
    console.log(res);
    return res;
  };

  // delete
  const deleteHandle = (id) => {
    get_allPosts();
  };
  // delete post
  const DeletePostHandle = (id) => {
    let conf = confirm("Haqiqatdan ham shu postni o'chirmoqchimisiz ?");
    if (conf === true) {
      DeleteData(id);
    } else {
      return;
    }
  };
  const DeleteData = async (id) => {
    const url = `http://164.90.236.174:1988/koinot/news/${id}`;
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };
    try {
      const res = await axios.delete(url, headers);
      deleteHandle(id);
      toast.error(`${id}-yangilik o'chirildi`);

      return res.data;
    } catch (error) {
      console.error(error);
      toast.error(
        `O'chirishda xatolik, internetni tekshiring yoki logout qilib qayta kiring`
      );

      return { error: true, error };
    }
  };
  return (
    <UpdateStyles>
      {/* navbar */}
      <List component="nav" disablePadding className="col-7 d-flex">
        {itemsToEdit.map((v, i) => (
          <ListItem
            button
            key={i}
            className={`list-group-item border-bottom border-info rounded text-center me-2 ${
              index == i ? "bg-info text-white" : ""
            }`}
            onClick={() => {
              setIndex(i);
            }}
          >
            <ListItemText primary={v.title} className="m-0" />
          </ListItem>
        ))}
      </List>
      {/* navbar end */}

      {/* edit tags */}
      {index == 0
        ? tags.length !== 0
          ? tags.map((v, i) => (
              <EditTag data={v} key={i} successCallback={successCallback} />
            ))
          : ""
        : ""}
      {/* edit tags end */}

      {/* edit categories */}
      {index == 1
        ? cats.length !== 0
          ? cats.map((v, i) => (
              <EditCat data={v} key={i} successCallback={successCallback} />
            ))
          : ""
        : ""}
      {/* edit posts */}
      {index == 2 ? (
        <div className="my-4">
          <div>
            <div className={pathBool ? "d-block" : "d-none"}>
              <h4>O'zgartirmoqchi bo'lgan yangiligingizni tanlang</h4>
              <br />
              <div id="top"></div>
              <TextField
                variant="filled"
                label="Search item"
                value={search}
                className="col-6"
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            {pathBool
              ? posts.length !== 0
                ? posts.map((v, i) => (
                    <div className="row my-3 p-2" key={i}>
                      <div className="col-10 border p-3">
                        <p
                          style={{
                            fontWeight: "bold",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {v.id}. {" " + v.titleUz}
                        </p>
                        {v.status === "IMPORTANT" ? (
                          <p className="small m-0">Dolzarb</p>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="col-2 border d-flex p-2">
                        <span className="col-4">
                          <Switches
                            checked={v.active}
                            onChange={(e) => changeActive(v.id, e)}
                          />
                        </span>
                        <span className="col-4">
                          <button
                            onClick={() => DeletePostHandle(v.id)}
                            className="btn btn-danger w-100 text-white fw-bold"
                          >
                            <BiTrash color="white" />
                          </button>
                        </span>
                        <span className="col-4" onClick={() => getPost(v.id)}>
                          <button className="btn btn-info w-100 text-white fw-bold">
                            <BiEditAlt className="text-white" />
                          </button>
                        </span>
                      </div>
                    </div>
                  ))
                : ""
              : ""}
            {pathBool ? (
              posts.length !== 0 ? (
                <Button
                  onClick={() => LoadHandler()}
                  variant="contained"
                  fullWidth
                  color="primary"
                  startIcon={<BiCloudDownload />}
                >
                  Load more
                </Button>
              ) : (
                ""
              )
            ) : (
              ""
            )}
          </div>

          {/* back button */}

          <div className={postsBoolean}>
            <Button
              onClick={() => {
                setMapBool(false);
                setChildBool(false);
                setPathBool(true);
                setPostsBoolean("d-none");
              }}
              variant="contained"
              color="primary"
              startIcon={<MdArrowBackIosNew />}
            >
              Back
            </Button>
            <br /> <br />
            {mapBool
              ? newsdto.map((v, i) => (
                  <EditPost
                    data={v}
                    success={(e) => setSuccess(e)}
                    successCallback={successCallback}
                    key={i}
                  />
                ))
              : ""}
            {childBool ? (
              <div>
                <hr className="bg-warning" />
                <h4>Children</h4>
                <hr />
                {children.map((v, i) => (
                  <EditPostChild
                    data={v}
                    parent={newsdto[0].id}
                    key={i}
                    success={(e) => setSuccess(e)}
                    successCallback={successCallback}
                  />
                ))}
              </div>
            ) : (
              "Ushbu Postga tegishli boshqa post mavjud emas"
            )}
            {mapBool ? (
              <Button
                onClick={() => AddChild()}
                variant="contained"
                fullWidth
                color="primary"
              >
                Postga tarkibiy qism qo'shish
              </Button>
            ) : (
              ""
            )}
          </div>
        </div>
      ) : (
        ""
      )}
      {/* toast */}
      <div>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>

      {/* toast */}
    </UpdateStyles>
  );
};

export default Update;



// WEBPACK FOOTER //
// ./src/Pages/Update/index.js